module.exports = __webpack_public_path__ + "static/media/sitebuilder-ai.f04df770.png";